/**
 * TG Activity Log types for tracking subcontractor activity
 */

export type TGActionType = 'page_view' | 'login'

export type TGPageName =
  | 'dashboard'
  | 'calendar'
  | 'assignments'
  | 'assignment_detail'
  | 'articles'
  | 'handbook'
  | 'profile'

export interface TGActivityLogEntry {
  id: string
  subcontractor_id: string
  user_id: string | null
  action_type: TGActionType
  page_name: TGPageName | null
  page_path: string | null
  entity_id: string | null
  metadata: Record<string, unknown> | null
  created_at: string
}

export interface TGActivityLogEntryWithSubcontractor extends TGActivityLogEntry {
  subcontractor_name: string
  subcontractor_email: string
}

export interface TGActivitySummary {
  subcontractor_id: string
  subcontractor_name: string
  is_active: boolean
  total_visits: number
  total_logins: number
  last_login: string | null
  last_activity: string | null
  page_visits: Record<TGPageName, number>
}

export const PAGE_NAME_LABELS: Record<TGPageName, string> = {
  dashboard: 'Dashboard',
  calendar: 'Kalender',
  assignments: 'Mina Uppdrag',
  assignment_detail: 'Uppdragsdetalj',
  articles: 'Artiklar',
  handbook: 'Handbok',
  profile: 'Min profil'
}
